module.exports = __webpack_public_path__ + "img/acerca_de-industrias_de_nutraceuticos.69203e5a.jpg";